module.exports = __webpack_public_path__ + "img/icon.e51a8ffe.svg";